import { call, put, takeEvery } from "redux-saga/effects";
import { GET_ADMINS_LIST, GET_ADMINS_SWITCHABLE_ACCS, REMOVE_SWITCH_ADMIN_ACCOUNT, SWITCH_ADMIN_ACCOUNT } from "./actionTypes";
import {
  adminSwitchableAccFail,
  adminSwitchableAccSuccess,
  getAdminsListFail,
  getAdminsListSuccess,
  removeAdminSwitchAccFail,
  removeAdminSwitchAccSuccess,
  switchAdminAccFail,
  switchAdminAccSuccess,
} from "./actions";
import { onGettingAdminsList, onGettingSwitchableAccs, onSwitchingAdminAccount, onRemovingAdminSwitchAcc } from "helpers/fakebackend_helper";

import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";

const toastTitle = "Admins";

function* onRemove({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onRemovingAdminSwitchAcc, data);
    yield call(responseHandler, toastTitle, response, removeAdminSwitchAccSuccess, removeAdminSwitchAccFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(removeAdminSwitchAccFail(error));
    showToast(error, toastTitle, error);
  }
}

function* onGet({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingAdminsList, data);
    yield call(responseHandler, toastTitle, response, getAdminsListSuccess, getAdminsListFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getAdminsListFail(error));
    showToast(error, toastTitle, error);
  }
}

function* onGetSwitchableAccs({ payload: { data, onSuccess, onError, header } }) {
  try {
    const response = yield call(onGettingSwitchableAccs, data, header);
    yield call(responseHandler, toastTitle, response, adminSwitchableAccSuccess, adminSwitchableAccFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(adminSwitchableAccFail(error));
    showToast(error, toastTitle, error);
  }
}

function* onSwitchAccount({ payload: { data, onSuccess, onError, header } }) {
  try {
    const response = yield call(onSwitchingAdminAccount, data, header);
    yield call(responseHandler, toastTitle, response, switchAdminAccSuccess, switchAdminAccFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(switchAdminAccFail(error));
    showToast(error, toastTitle, error);
  }
}

export function* AdminsSaga() {
  yield takeEvery(GET_ADMINS_LIST, onGet);
  yield takeEvery(SWITCH_ADMIN_ACCOUNT, onSwitchAccount);
  yield takeEvery(REMOVE_SWITCH_ADMIN_ACCOUNT, onRemove);
  yield takeEvery(GET_ADMINS_SWITCHABLE_ACCS, onGetSwitchableAccs);
}

export default AdminsSaga;
